var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconfont",class:_vm.type,style:({ color: _vm.color, 'font-size': _vm.iconSize }),on:{"click":_vm._onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }